import {HighLowTransformer as Transformer} from './high-low-transformer'
import { interpolate } from 'd3-interpolate'
import * as geo from 'd3-geo'
import { get as getProjection, FEATURES} from '..'
import interpolatedProjection from './interpolated-projection'

export default class NorthAmerica extends Transformer {

  static match (d0, d1) {
    if (!d0) {
      return false
    }

    return d1.node.key == FEATURES.NORTH_AMERICA || // World to north america
          d0.node.key == FEATURES.NORTH_AMERICA // North America to something else
  }

  /*
   * Configures the low resolution map objects.
   */
  configureLowRes (low, highData, opts) {
    let lowData = low.datum()
      , lowGeo = this._buildFeatureCollection(lowData.zoomedTo, lowData.geojson)

    // Set the fit size on the projection
    lowData.projection.fitSize([opts.width, opts.height], lowGeo)

    // Grab the high res feature within the low res map
    this.lowRes = this.low.selectAll('path').filter(feature => feature.id == highData.id)

    let lowResProjectionA = getProjection(lowData.node, lowGeo, opts) // Current projection
      , lowResProjectionB = getProjection(highData.node, highData.geojson, opts)

    this.lowResInterpolater = interpolatedProjection(lowResProjectionA, lowResProjectionB)
    this.lowResPath = geo.geoPath().projection(this.lowResInterpolater)

    // Determine the scales of the low feature
    let projection = getProjection(lowData.node, lowGeo, opts)
      , scale0 = projection.scale()
      , translate0 = projection.translate()

    // Now blow up the low res projection so it's focused on the high
    // res feature
    projection.fitSize([opts.width, opts.height], {
      type: 'FeatureCollection',
      features: this.lowZoomed(highData)
    })

    this.lowInterpolaters = {
      scale: interpolate(scale0, projection.scale()),
      translate: interpolate(translate0, projection.translate())
    }

    this.lowPath = lowData.path
  }

  /*
   * Configures the transformer's high resolution objects. The high
   * resolution feature's final projection is fit to its geojson. The feature
   * starts using a projection based on the the low resolution map zoomed
   */
  configureHighRes (high, lowData, opts) {
    let highData = high.datum()
      , lowGeo = this._buildFeatureCollection(lowData.zoomedTo, lowData.geojson)

    highData.projection.fitSize([opts.width, opts.height], highData.geojson)

    let highProjectionA = getProjection(lowData.node, lowGeo, opts)
      , highProjectionB = highData.projection

    this.highInterpolater = interpolatedProjection(highProjectionA, highProjectionB)
    this.highPath = geo.geoPath().projection(this.highInterpolater)

  }

  resolutions (enter, exit) {
    let enterKey = enter.datum().node.key
      , exitKey = exit.datum().node.key
      , high, low

    if ([enterKey, exitKey].some(key => key == FEATURES.WORLD)) {
      // World <-> North America
      high = enterKey == FEATURES.NORTH_AMERICA ? enter : exit
      low = enterKey == FEATURES.NORTH_AMERICA ? exit : enter
    } else {
      high = enterKey == FEATURES.NORTH_AMERICA ? exit : enter
      low = enterKey == FEATURES.NORTH_AMERICA ? enter : exit
    }

    return {high, low}
  }

  transform (t) {
    if (this.zoomOut) {
      // Reverse the transformation
      t = 1 - t
    }

    this.highInterpolater.alpha(t)
    this.high
        .selectAll('path')
        .attr('d', this.highPath)

    this.low
        .datum().projection
        .scale(this.lowInterpolaters.scale(t))
        .translate(this.lowInterpolaters.translate(t))

    this.low
        .selectAll('path')
        .attr('d', d => this.lowPath(d))

    this.lowResInterpolater.alpha(t)
    this.lowRes.attr('d', this.lowResPath)
  }

}
